import React, { useState, useEffect } from "react";
import moment from "moment";
import { useHistory } from "react-router";
import { useParams } from "react-router-dom";
import httpService from "../../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../../helpers/spinner";
import helperNumber from "../../../../../helpers/numbers";
import helperTime from "../../../../../helpers/time";
import Sidebar from "../../../../partials/aside/Sidebar";
import TypesStatusCampaigns from "./TypesStatusCampaigns";
import discountTypeAmount from "../../../discount/campaign-banner/type-amount";
import TitleBar from "../../../../partials/content/TitleBar";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

function ViewCampaign() {
  const params = useParams();
  const campaignID = params.id;
  const [campaign, setCampaign] = useState(null);
  const [
    amountOneDayCampaignWithoutDiscount,
    setAmountOneDayCampaignWithoutDiscount,
  ] = useState(0);
  const history = useHistory();

  useEffect(() => {
    getCategoriesUserSitesPublisher();
  }, []);

  useEffect(() => {
    if (!campaign) {
      return;
    }
    if (Object.keys(campaign.discount).length == 0) {
      return;
    }

    setAmountOneDayCampaignWithoutDiscount(
      getAmountWithoutDiscount(
        campaign.discount,
        campaign.amount / calculateDays()
      )
    );
  }, [campaign]);

  const getCategoriesUserSitesPublisher = async () => {
    let campaign = await sendRequestGetCategoriesUserSitesPublisher(campaignID);
    if (!campaign) {
      return;
    }
    setCampaign(campaign);
  };

  const sendRequestGetCategoriesUserSitesPublisher = async (campaignID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const headersRequest = getHeaderForRequest();
    let categoryAllPublisher;
    try {
      categoryAllPublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/campaign/banner/simple/" +
          campaignID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return categoryAllPublisher.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const calculateDays = () => {
    if (campaign === null) {
      return;
    }

    let startDate = helperTime.convertJalaliToGregorian(
      campaign.start_date.split(" ")[0]
    );
    let endDate = helperTime.convertJalaliToGregorian(
      campaign.end_date.split(" ")[0]
    );

    startDate = moment(startDate);
    endDate = moment(endDate);
    return endDate.diff(startDate, "days") + 1;
  };

  const disableCampaign = async (e) => {
    e.preventDefault();
    const result = window.confirm(
      "آیا مطمئن هستید؟ توجه داشته باشید در صورت غیرفعال کردن کمپین مبلغ بیعانه کمپین به هیچ عنوان به موجودی حساب کاربری شما بازگردانده نمیشود."
    );
    if (!result) {
      return;
    }

    if (await sendRequestDisableCampaign(campaignID)) {
      history.push("/campaigns/all");
    }
  };

  const sendRequestDisableCampaign = async (campaignID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/campaign/banner/simple/disable/" +
          campaignID,
        {},
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return true;
  };

  const getAmountWithoutDiscount = (discount, amount) => {
    let newAmount = 0;
    if (
      discountTypeAmount.typeAmountString.PRICE ==
      discount.type_amount.toUpperCase()
    ) {
      newAmount = amount + discount.amount;
    } else if (
      discountTypeAmount.typeAmountString.PERCENT ==
      discount.type_amount.toUpperCase()
    ) {
      newAmount = Math.floor((amount * 100) / (100 - discount.amount));
    }
    return newAmount;
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="نمایش تنظیمات کمپین بنری ساده" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link to="/campaigns/all" className="btn btn-primary">
                  <span className="pl-2">بازگشت</span>
                  <span>
                    <i className="fa fa-arrow-left"></i>
                  </span>
                </Link>
              </div>

              <div className="table-responsive pb-4">
                <table className="table table-hilite tbl-td-white-space table-hover m-0">
                  <thead>
                    <tr>
                      <td
                        colSpan={2}
                        className="text-center"
                        style={{ borderRadius: "25px 25px 0 0" }}
                      >
                        <b>اطلاعات کمپین</b>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <label className="pl-1">نام کمپین : </label>
                      </td>
                      <td>
                        <label className="pr-2">{campaign?.name}</label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label className="pl-1">
                          نام گروه نمایش دهنده بنری :{" "}
                        </label>
                      </td>
                      <td>
                        <label className="pr-2">{campaign?.category}</label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label className="pl-1">تعداد جایگاه</label>
                      </td>
                      <td>
                        <label className="pr-2">
                          {helperNumber.toPersianNum(campaign?.count_positions)}
                        </label>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <label className="pl-1">تاریخ شروع</label>
                      </td>
                      <td>
                        <span className="number-finance">
                          <label className="pr-2" dir="ltr">
                            {helperNumber.toPersianNum(campaign?.start_date)}
                          </label>
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <label className="pl-1">تاریخ پایان</label>
                      </td>
                      <td>
                        <span className="number-finance">
                          <label className="pr-2" dir="ltr">
                            {helperNumber.toPersianNum(campaign?.end_date)}
                          </label>
                        </span>
                      </td>
                    </tr>

                    {amountOneDayCampaignWithoutDiscount ? (
                      <tr>
                        <td>
                          <label className="pl-1 text-danger">
                            کد تخفیف استفاده شده :{" "}
                          </label>
                        </td>
                        <td>
                          <span className="pl-2 text-danger ">
                            <label>{campaign.discount.title}</label>
                            <label className="px-3 letter-spacing-finance-number">
                              {helperNumber.toPersianNum(
                                helperNumber.toFormatFinanceNumber(
                                  campaign.discount.amount
                                )
                              )}
                            </label>
                            <label>
                              {discountTypeAmount.typeAmountString.PRICE ==
                              campaign.discount.type_amount.toUpperCase()
                                ? discountTypeAmount.typeAmountStringPersian
                                    .PRICE
                                : ""}
                              {discountTypeAmount.typeAmountString.PERCENT ==
                              campaign.discount.type_amount.toUpperCase()
                                ? discountTypeAmount.typeAmountStringPersian
                                    .PERCENT
                                : ""}
                            </label>
                          </span>
                        </td>
                      </tr>
                    ) : (
                      <></>
                    )}

                    <tr>
                      <td>
                        <label>مبلغ یک شبانه روز کمپین</label>
                      </td>
                      <td>
                        {amountOneDayCampaignWithoutDiscount ? (
                          <>
                            <label className=" letter-spacing-finance-number text-decoration-line-through">
                              {helperNumber.toPersianNum(
                                helperNumber.toFormatFinanceNumber(
                                  amountOneDayCampaignWithoutDiscount
                                )
                              )}
                            </label>
                            <label className="px-2 text-decoration-line-through">
                              تومان
                            </label>
                          </>
                        ) : (
                          <></>
                        )}
                        <span>
                          <label
                            className={` letter-spacing-finance-number 
                          ${
                            amountOneDayCampaignWithoutDiscount
                              ? "text-danger"
                              : ""
                          }    `}
                          >
                            {helperNumber.toPersianNum(
                              helperNumber.toFormatFinanceNumber(
                                campaign?.amount / calculateDays()
                              )
                            )}
                          </label>
                          <label
                            className={`pr-2     ${
                              amountOneDayCampaignWithoutDiscount
                                ? "text-danger"
                                : ""
                            } `}
                          >
                            تومان
                          </label>
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label>مبلغی که در هر ساعت کسر میشود</label>
                      </td>
                      <td>
                        {amountOneDayCampaignWithoutDiscount ? (
                          <span>
                            <label className="letter-spacing-finance-number text-decoration-line-through">
                              {helperNumber.toPersianNum(
                                helperNumber.toFormatFinanceNumber(
                                  Math.floor(
                                    amountOneDayCampaignWithoutDiscount / 24
                                  )
                                )
                              )}
                            </label>
                            <label className="px-2 text-decoration-line-through">
                              تومان
                            </label>
                          </span>
                        ) : (
                          <></>
                        )}

                        <span>
                          <label
                            className={` letter-spacing-finance-number 
                       ${
                         amountOneDayCampaignWithoutDiscount
                           ? "text-danger"
                           : ""
                       }    `}
                          >
                            {helperNumber.toPersianNum(
                              helperNumber.toFormatFinanceNumber(
                                Math.floor(
                                  campaign?.amount / calculateDays() / 24
                                )
                              )
                            )}
                          </label>
                          <label
                            className={` pr-2 ${
                              amountOneDayCampaignWithoutDiscount
                                ? "text-danger"
                                : ""
                            }    `}
                          >
                            تومان
                          </label>
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label>تعداد شبانه روز کمپین</label>
                      </td>
                      <td>
                        <span>
                          <label>
                            {helperNumber.toPersianNum(calculateDays())}
                          </label>
                          <label className="pr-2">شبانه روز</label>
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <label>مبلغ کمپین</label>
                      </td>
                      <td>
                        {amountOneDayCampaignWithoutDiscount ? (
                          <span>
                            <label className="letter-spacing-finance-number text-decoration-line-through">
                              {helperNumber.toPersianNum(
                                helperNumber.toFormatFinanceNumber(
                                  Math.floor(
                                    amountOneDayCampaignWithoutDiscount *
                                      calculateDays()
                                  )
                                )
                              )}
                            </label>
                            <label className="px-2 text-decoration-line-through">
                              تومان
                            </label>
                          </span>
                        ) : (
                          <></>
                        )}

                        <span>
                          <label
                            className={` letter-spacing-finance-number 
                        ${
                          amountOneDayCampaignWithoutDiscount
                            ? "text-danger"
                            : ""
                        }    `}
                          >
                            {helperNumber.toPersianNum(
                              helperNumber.toFormatFinanceNumber(
                                campaign?.amount
                              )
                            )}
                          </label>
                          <label
                            className={` pr-2  
${amountOneDayCampaignWithoutDiscount ? "text-danger" : ""}    `}
                          >
                            تومان
                          </label>
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <label>مبلغ بیعانه کمپین</label>
                      </td>
                      <td>
                        {amountOneDayCampaignWithoutDiscount ? (
                          <span>
                            <label className="letter-spacing-finance-number text-decoration-line-through">
                              {helperNumber.toPersianNum(
                                helperNumber.toFormatFinanceNumber(
                                  Math.floor(
                                    (amountOneDayCampaignWithoutDiscount *
                                      calculateDays()) /
                                      process.env.REACT_APP_DEPOSIT_COEFFICIENT
                                  )
                                )
                              )}
                            </label>
                            <label className="px-2 text-decoration-line-through">
                              تومان
                            </label>
                          </span>
                        ) : (
                          <></>
                        )}

                        <span>
                          <label
                            className={` letter-spacing-finance-number 
                    ${
                      amountOneDayCampaignWithoutDiscount ? "text-danger" : ""
                    }    `}
                          >
                            {helperNumber.toPersianNum(
                              helperNumber.toFormatFinanceNumber(
                                campaign?.pledge_amount
                              )
                            )}
                          </label>
                          <label
                            className={` px-2  
                     ${
                       amountOneDayCampaignWithoutDiscount ? "text-danger" : ""
                     }    `}
                          >
                            تومان
                          </label>
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <label>مبلغ کل کمپین</label>
                      </td>
                      <td>
                        {amountOneDayCampaignWithoutDiscount ? (
                          <span>
                            <label className="letter-spacing-finance-number text-decoration-line-through">
                              {helperNumber.toPersianNum(
                                helperNumber.toFormatFinanceNumber(
                                  amountOneDayCampaignWithoutDiscount *
                                    calculateDays() +
                                    Math.floor(
                                      (amountOneDayCampaignWithoutDiscount *
                                        calculateDays()) /
                                        process.env
                                          .REACT_APP_DEPOSIT_COEFFICIENT
                                    )
                                )
                              )}
                            </label>
                            <label className="px-2 text-decoration-line-through">
                              تومان
                            </label>
                          </span>
                        ) : (
                          <></>
                        )}

                        <span>
                          <label
                            className={` letter-spacing-finance-number 
                     ${
                       amountOneDayCampaignWithoutDiscount ? "text-danger" : ""
                     }    `}
                          >
                            {helperNumber.toPersianNum(
                              helperNumber.toFormatFinanceNumber(
                                campaign?.total_amount
                              )
                            )}
                          </label>
                          <label
                            className={` px-2  
                       ${
                         amountOneDayCampaignWithoutDiscount
                           ? "text-danger"
                           : ""
                       }    `}
                          >
                            تومان
                          </label>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {campaign?.status ==
                TypesStatusCampaigns.statusCampaign.PENDING_TO_START_DATE ||
              campaign?.status == TypesStatusCampaigns.statusCampaign.ACTIVE ? (
                <>
                  <div>
                    <div className="alert alert-danger">
                      <span className="pl-2">
                        <i className="fa fa-info"></i>
                      </span>
                      <span>
                        توجه داشته باشید در صورت غیرفعال کردن کمپین مبلغ بیعانه
                        کمپین به هیچ عنوان به موجودی حساب کاربری شما بازگردانده
                        نمیشود.
                      </span>
                    </div>
                  </div>
                  <button className="btn btn-warning" onClick={disableCampaign}>
                    <span className="pl-2">
                      <i className=" fa fa-power-off"></i>
                    </span>
                    <span>لغو کردن کمپین</span>
                  </button>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default ViewCampaign;
